import { gql } from '@/__generated__';

const DEVICE_DOCUMENT_PRESIGNED_URL = gql(`#graphql
  query DeviceDocumentPresignedUrl($fileUrl: String!) {
    deviceDocumentPresignedUrl(fileUrl: $fileUrl)
  }
`);

export default DEVICE_DOCUMENT_PRESIGNED_URL;
